"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultItemPreset = exports.defaultHeaderButton = exports.defaultImageConfig = void 0;
var defaultImageConfig = {
    margin: {
        desktop: '0',
        tablet: '0',
        mobile: '0'
    },
    imageConfig: {
        width: '120px',
        shadow: 'none',
        border: 'none'
    }
};
exports.defaultImageConfig = defaultImageConfig;
var defaultHeaderButton = {
    backgroundColor: 'transparent',
    fontSize: '20px'
};
exports.defaultHeaderButton = defaultHeaderButton;
var defaultItemPreset = {
    defaultCss: {
        background: 'unset !important'
    },
    underlineColor: '#FFC000'
};
exports.defaultItemPreset = defaultItemPreset;
//# sourceMappingURL=Header.js.map